module.exports = __webpack_public_path__ + "static/media/delapwaller.7bdaf2ab.png";